import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useAnalytics } from "./useAnalytics";

export default function useGaPageViews() {
  const location = useLocation();
  const { trackPageView } = useAnalytics();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location, trackPageView]);
}
